<template>
  <div>

    <v-layout ma-2 row wrap v-for="contact in contacts" :key="contact.contactId">

      <v-flex xs7 ma-4>
        <v-select
          :items="countries"
          v-model="dirtyCountriesSelected[contact.contactId]"
          label="Customers from these countries:"
          item-text="name"
          item-value="alpha2"
          multiple
        ></v-select>

      </v-flex>
      <v-flex xs4 ml-6>
        <i><small class="grey--text text--darken-2">send returns to this contact:</small></i>
        <div>
          Contact ID: {{contact.contactId}}
        </div>
        <div>
          <b>{{contact.contactText1}} {{contact.contactText2}}</b>
        </div>
        <div>
          {{contact.street}}
        </div>
        <div>
          {{contact.zipcode}} {{contact.city}}
        </div>
        <br/><br/>
      </v-flex>
    </v-layout>

    <v-layout row wrap ma-2>
      <v-flex xs12>
        <i>The following countries are not mapped and therefore customers from these countries can not send a return to this customer:</i>
        <i>
          {{notMappedCountries.map(c => c.name).join(", ")}}
        </i>

      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      showSaveButton: false,
      dirtyCountriesSelected: Object.assign({}, this.countriesSelected)
    }
  },

  props: {
    contacts: Array,
    countriesSelected: Object
  },

  computed: {
    ...mapState({
      countries: state => state.config.countries
    }),

    notMappedCountries() {
        const selectedCountries = Object.values(this.dirtyCountriesSelected).reduce((acc, cur) => acc.concat(cur), [])

        return this.countries
          .filter(item => {
            return !selectedCountries.includes(item.alpha2)
          })
      },
  },

  watch: {
    countriesSelected(val, oldVal) {
      this.dirtyCountriesSelected = val
    },

    dirtyCountriesSelected: {
      handler: function(newVal, oldVal) {
        this.$emit('change', this.exportToPayload(newVal))
      },
      deep: true
    }
  },

  methods: {
    exportToPayload(countriesSelected) {
      return Object.entries(countriesSelected)
        .map( ([contactId, countries]) => {
          return countries.map( country => ({
            destinationContactId: contactId,
            originCountry: country
          }))
        }).reduce((acc, cur) => acc.concat(cur), [])
    }
  }
}
</script>



// WEBPACK FOOTER //
// IsrsCountryMappingForm.vue?cf69193e